import Vue, { CreateElement, RenderContext, VNode } from "vue";

interface Props {
  fontSize: string | number | undefined;
  color: string;
}

export default Vue.extend({
  functional: true,
  name: "BaseIcon",
  props: {
    fontSize: { type: [String, Number] },
    color: { type: String },
  },
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    let { fontSize } = ctx.props;
    fontSize = typeof fontSize === "string" && !isNaN(parseFloat(fontSize)) ? parseFloat(fontSize) : fontSize;
    if (typeof fontSize === "number") fontSize = fontSize + "px";
    const slot = ctx.scopedSlots.default && ctx.scopedSlots.default(0);
    const iconName = !slot || !slot[0].text ? "" : slot[0].text.trim();
    if (!iconName) return { text: "", isComment: true, isRootInsert: false };
    const iconType = /^fa[a-z] fa-/.test(iconName) ? "" : iconName.split("-")[0];
    const style = (Array.isArray(ctx.data.style) ? ctx.data.style : [ctx.data.style])
      .concat([ctx.data.staticStyle])
      .concat({ height: fontSize });
    if (/sci-color.*/.test(iconName)) {
      return (
        <img
          class={(Array.isArray(ctx.data.class) ? ctx.data.class : [ctx.data.class]).concat([
            iconType,
            iconName,
            ctx.data.staticClass,
          ])}
          style={style}
          on={ctx.listeners}
          src={`/img/icons/${iconName}.svg`}
        />
      );
    }
    return (
      <span
        class={(Array.isArray(ctx.data.class) ? ctx.data.class : [ctx.data.class]).concat([
          iconType,
          iconName,
          ctx.data.staticClass,
        ])}
        style={(Array.isArray(ctx.data.style) ? ctx.data.style : [ctx.data.style]).concat([
          { fontSize, color: ctx.props.color },
          ctx.data.staticStyle,
        ])}
        on={ctx.listeners}
      />
    );
  },
});
